import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import Shared from 'screens/shared';
import { Paper } from '@mui/material';
import CreateForm from 'screens/kubernetes/cluster/create';
import { _t, capitalize, getLanColor } from 'utils';
import { Redirect } from 'react-router-dom';
import { ROUTE, K8S_CLUSTER_STATE } from 'constant';
import PropertiesTable from 'screens/shared/properties-table';
import Nodes from './nodes';

export default ({ match = {} }) => {
  const { params = {} } = match;
  const { cluster: clusterId = '', nodepool: nodepoolId = '' } = params;

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [, successes] = Shared.hooks.useNotification({
    actions: [ACTIONS_TYPES.KUBERNETES.NODEPOOL.DELETE],
  });

  const { nodepool = {} } = useSelector((e) => e);
  const { properties = {}, metadata = {} } = nodepool;
  const { state = '' } = metadata;
  const {
    name = '', k8sVersion, maintenanceWindow = {}, autoScaling = {}, lans = [],
  } = properties;
  const { dayOfTheWeek, time } = maintenanceWindow;

  const { maxNodeCount = 0, minNodeCount = 0 } = autoScaling;
  const isAutoScaling = !!maxNodeCount || !!minNodeCount;

  useEffect(() => {
    actions.kubernetes.cluster.get({ id: clusterId });
    actions.kubernetes.nodepool.get({ clusterId, id: nodepoolId });
    actions.kubernetes.node.getAll({ nodepoolId, clusterId });
  }, [clusterId, nodepoolId]);

  useEffect(() => {
    actions.common.setLayoutTitle({
      layout: { title: 'Nodepool', menu: ROUTE.DASHBOARD.KUBERNETES.key },
    });
  }, []);

  const onDelete = (isDelete) => {
    setShowConfirmDialog(false);
    if (isDelete) {
      actions.kubernetes.nodepool.delete({ clusterId, id: nodepoolId });
    }
  };

  const LanRenderer = ({ id, routes, dhcp }) => (
    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 5 }} key={id}>
      <div className="lan-selector-option" style={{ position: 'relative', display: 'inline' }}>
        <Shared.widgets.Icon
          name="ethernet"
          style={{
            backgroundColor: getLanColor(id), paddingBottom: 9, paddingTop: 2, borderRadius: 'var(--border-radius)', fontSize: 15,
          }}
        />
        <span style={{
          position: 'absolute', bottom: 1, left: 0, lineHeight: '9px', fontSize: 6, color: 'white', width: 25, textAlign: 'center',
        }}
        >
          {`LAN ${id}`}
        </span>
      </div>
      <div>
        {`DHCP: ${dhcp ? '✓' : '✗'} ${_t('KUBERNETES.NODE_POOL.FIELDS.ROUTES')}: ${routes?.length || 0}`}
      </div>
    </div>
  );

  const _autoScaling = [];
  if (minNodeCount) {
    _autoScaling.push(['Min Node Count', minNodeCount]);
  }

  if (maxNodeCount) {
    _autoScaling.push(['Max Node Count', maxNodeCount]);
  }

  const propertiesValues = [
    ['Autoscaling', isAutoScaling ? 'ON' : 'OFF'],
    ..._autoScaling,
    ['LANs', lans.length ? lans.map((e) => LanRenderer(e)) : 'Not Selected'],
  ];

  return (
    <div className="screen-server">
      <div className="strap">
        <div className="strap-details">
          <Shared.widgets.Icon name="boxes" style={{ fontSize: 30 }} />
          <div style={{ marginLeft: 15 }}>
            <span style={{ display: 'block', marginLeft: 0 }} className="strap-details-title">
              {name}
              <Shared.utilities.Separator />
              {k8sVersion}
            </span>
            <span style={{ display: 'flex', justifyItems: 'center' }}>
              <Shared.utilities.StatusLED state={state} />
              <span style={{ marginLeft: 5, fontSize: 12 }}>
                {capitalize(state)}
                <Shared.utilities.Separator />
                <Shared.widgets.Icon name="clock" style={{ color: '#707070' }} />
                {' '}
                {time}
                <Shared.utilities.Separator />
                <Shared.widgets.Icon name="calendar-day" style={{ color: '#707070' }} />
                {' '}
                {dayOfTheWeek}
              </span>
            </span>
          </div>
        </div>
        {state === K8S_CLUSTER_STATE.ACTIVE ? (
          <div className="strap-details-icons">
            <Shared.widgets.Icon
              name="trash"
              className="danger-txt"
              onClick={() => setShowConfirmDialog(true)}
            />
            <Shared.widgets.Icon
              name="edit"
              onClick={() => setIsUpdate(!isUpdate)}
            />
          </div>
        ) : (
          <div>
            <Shared.widgets.Loader isInline show size={22} />
          </div>
        )}
      </div>
      {isUpdate && (
        <Paper className="screen-common">
          <CreateForm
            isUpdate
            nodepool={{ id: nodepool.id, properties: { ...nodepool.properties } }}
            isCancel
            onCancel={() => setIsUpdate(false)}
          />
        </Paper>
      )}
      <PropertiesTable properties={propertiesValues} />
      <Nodes
        clusterId={clusterId}
        nodepoolId={nodepoolId}
        nodepoolState={state}
      />
      <Shared.dialog.Confirm show={showConfirmDialog} onClose={onDelete} />
      {!!successes.length && <Redirect to={`/kubernetes/${clusterId}`} />}
    </div>
  );
};
